import { useFeatureFlags } from "@/core/auth/hooks";
import { TriangleAlert } from "lucide-react";
import { useTranslation } from "react-i18next";

/**
 * Payment-overdue notice for a restricted organization. Sits alongside
 * {@link ReadOnlyBanner} in MainLayout, so it shows on every authenticated
 * page; the two stack when a super admin inspects a restricted org.
 */
export const RestrictedBanner = () => {
  const { restricted } = useFeatureFlags();
  const { t } = useTranslation("layout");

  if (!restricted) {
    return null;
  }

  return (
    <div className="flex items-center justify-center gap-2 bg-red-100 px-4 py-1.5 text-sm text-red-900">
      <TriangleAlert className="size-4" />
      <span>{t("restrictedBanner")}</span>
    </div>
  );
};
